
import { defineComponent } from "vue";
export default defineComponent({
  name: "ResultsReturned",
  props: {
    totalResults: {
      type: Number,
      required: true,
      default: 0
    },
    indexType: {
      type: String,
      required: true,
      default: ""
    }
  }
});
